import React from 'react';
import classNames from 'classnames';

import { CommonProps } from '../../components/helpers/props';
import { ErrorPageIcons, ErrorPageIconComponent, PageNotFoundIcon } from 'fasoo-ui-component-next';
import { Button } from 'fasoo-ui-component-next';

import './index.scss';
import { ResourceType, t } from 'src/shared/types/ResourceType';
import useAuthStore from 'src/hooks/auth/useAuthStore';
import { getFasooUiComponentLanguage } from 'src/i18n';

const resource: ResourceType = {
  ko: {
    notFound: '페이지를 찾을 수 없습니다.',
    forbidden1: '이 페이지를 볼 권한이 없습니다.홈으로 이동하여 관리자 계정으로 로그인하십시오.',
    forbidden2: '홈으로 이동하여 관리자 계정으로 로그인하십시오.',
    goBack: '홈으로 이동',
  },
  en: {
    notFound: 'Page not found',
    forbidden1: "You don't have permission to open this page.",
    forbidden2: '<br />Please go to home and log in with an admin account.',
    goBack: 'Go Home',
  },
};

export interface SingleErrorPageProps extends CommonProps {
  lang?: 'ko' | 'en';
  iconComponent: ErrorPageIconComponent;
  text: string | React.ReactNode;
  startSignOut: () => {
    payload: undefined;
    type: string;
  };
}

const SingleErrorPage: React.FC<SingleErrorPageProps> = ({
  lang = 'ko',
  iconComponent: IconComponent,
  startSignOut,
  text,
  classes,
}) => {
  const handleClickSignOut = (): void => {
    startSignOut();
  };

  return (
    <div className={classNames('single-error-page-root', classes)}>
      <div className="content-area">
        <span className="single-error-page-icon-area">
          <IconComponent />
        </span>
        <div className="single-error-page-message-area">{text}</div>
        <div className="single-error-page-button-area">
          <Button text={t('goBack', lang, resource)} onClick={handleClickSignOut} />
        </div>
      </div>
      <div className="copy-right-area">Copyright © Fasoo Co., Ltd. All rights reserved.</div>
    </div>
  );
};

export interface ErrorPageProps extends CommonProps {
  lang?: 'ko' | 'en';
  startSignOut: () => {
    payload: undefined;
    type: string;
  };
}

const NotFound: React.FC<ErrorPageProps> = ({ classes, lang = 'ko', startSignOut }) => {
  return (
    <SingleErrorPage
      classes={classes}
      startSignOut={startSignOut}
      iconComponent={PageNotFoundIcon}
      text={t('notFound', lang, resource)}
      lang={lang}
    />
  );
};
const Forbidden: React.FC<ErrorPageProps> = ({ classes, lang = 'ko', startSignOut }) => {
  return (
    <SingleErrorPage
      classes={classes}
      startSignOut={startSignOut}
      iconComponent={ErrorPageIcons.Forbidden}
      lang={lang}
      text={
        <React.Fragment>
          {t('forbidden1', lang, resource)}
          <br />
          {t('forbidden2', lang, resource)}
        </React.Fragment>
      }
    />
  );
};

const NotFoundOutside: React.FC = () => {
  const { startSignOut } = useAuthStore();
  return <NotFound startSignOut={startSignOut} lang={getFasooUiComponentLanguage()} />;
};

const ForbiddenOutside: React.FC = () => {
  const { startSignOut } = useAuthStore();
  return <Forbidden startSignOut={startSignOut} lang={getFasooUiComponentLanguage()} />;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  NotFoundOutside,
  ForbiddenOutside,
};
